import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Alert, ModalComp } from "../";
import { withRouter } from "react-router-dom";
import { ScenariosWidgets } from "./ScenariosWidgets";
import { useTranslation } from "react-i18next";
import { FiHome, FiZap, FiCheck } from "react-icons/fi";

const ScenariosZone = (props) => {
  const { t } = useTranslation();
  const { title, icon, setScenarioCommand, scenarioId } = props;

  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [zoneIndex, setZoneIndex] = useState();
  const [zoneId, setZoneId] = useState();
  const token = Cookies.get("token");
  const [zoneCaption, setZoneCaption] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [openScenariosWidgets, setOpenScenariosWidgets] = useState(false);
  const toggleScenariosWidgets = () => {
    setOpenScenariosWidgets(!openScenariosWidgets);
  };

  const zoneClicked = (value, index) => {
    setZoneCaption(value.zone_caption);
    setZoneIndex(index);
    setZoneId(value.id);
    setOpenScenariosWidgets(true);
  };

  return (
    <>
      <ModalComp
        modal={openScenariosWidgets}
        toggle={toggleScenariosWidgets}
        component={
          <ScenariosWidgets
            id={zoneId}
            setScenarioCommand={setScenarioCommand}
            scenarioId={scenarioId}
            zoneCaption={zoneCaption}
          />
        }
      />
      
      <div className="scenarios-zone-container">
        {/* Header */}
        <div className="scenarios-zone-header">
          <div className="scenarios-zone-icon">
            <FiHome size={22} />
          </div>
          <h3 className="scenarios-zone-title">{t("انتخاب ناحیه")}</h3>
        </div>

        <p className="scenarios-zone-description">
          {t("ناحیه ای که دستگاه شما در آن قرار دارد را انتخاب نمایید.")}
        </p>

        {/* Scenario Info Card */}
        <div className="scenarios-zone-info">
          <div className="scenarios-zone-info-icon">
            <i className={`${icon}`}></i>
          </div>
          <div className="scenarios-zone-info-text">
            <span className="scenarios-zone-info-label">{t("سناریو")}</span>
            <span className="scenarios-zone-info-title">{title}</span>
          </div>
        </div>

        {/* Zones List */}
        <div className="scenarios-zone-list">
          {dashboardZones?.map((zone, index) => {
            const isActive = zoneIndex === index;
            return (
              <div
                className={`scenarios-zone-item ${isActive ? "active" : ""}`}
                key={index}
                onClick={() => zoneClicked(zone, index)}
              >
                <div className="scenarios-zone-item-icon">
                  <FiHome size={16} />
                </div>
                <span className="scenarios-zone-item-name">
                  {zone.zone_caption}
                </span>
                {isActive && (
                  <div className="scenarios-zone-item-check">
                    <FiCheck size={14} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

const ScenariosZones = withRouter(ScenariosZone);

export { ScenariosZones };